import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@nebular/theme";
import * as i3 from "../text-change.service";
import * as i4 from "@angular/platform-browser";
import * as i5 from "../../../../../deploy-url";
export class RealmSettingService {
    constructor(http, themeService, textChangeService, titleService, deployUrl) {
        this.http = http;
        this.themeService = themeService;
        this.textChangeService = textChangeService;
        this.titleService = titleService;
        this.deployUrl = deployUrl;
        this.realmConfigs = new BehaviorSubject(null);
        this.extendedRealmConfigs = new BehaviorSubject(null);
    }
    setConfigs() {
        return Promise.all([
            this.setRealmConfigs(),
            this.setExtendedRealmConfigs(),
        ]).then((result) => this.textChangeService.loadTexts());
    }
    setRealmConfigs() {
        return new Promise((resolve, reject) => {
            this.http.get('/api/config').subscribe((next) => {
                this.realmConfigs.next(next);
                resolve();
            }, (error) => {
                resolve();
            });
        });
    }
    getRealmConfigs() {
        return this.realmConfigs.asObservable();
    }
    setExtendedRealmConfigs() {
        return new Promise((resolve, reject) => {
            this.http.get('/api/config/extra').subscribe((extra) => {
                this.extendedRealmConfigs.next(extra);
                if (extra && extra.businessName) {
                    this.titleService.setTitle(extra.businessName);
                }
                if (extra && extra.theme) {
                    let theme = extra.theme;
                    if (localStorage.getItem('darkMode') === 'true') {
                        theme = theme + '-dark';
                    }
                    this.themeService.changeTheme(theme);
                    this.updateFavicon(theme);
                    this.updateManifest(theme);
                }
                resolve();
            }, (error) => {
                resolve();
            });
        });
    }
    getExtendedRealmConfigs() {
        return this.extendedRealmConfigs.asObservable();
    }
    updateFavicon(theme) {
        theme = this.resolveTheme(theme);
        if (!theme) {
            return;
        }
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.href = `${this.deployUrl}assets/images/${theme}-theme/favicon.ico`;
        document.head.appendChild(link);
    }
    updateManifest(theme) {
        if (!theme) {
            const extra = this.extendedRealmConfigs.getValue();
            if (!extra || !extra.theme) {
                return;
            }
            theme = extra.theme;
        }
        const extra = this.extendedRealmConfigs.getValue();
        const sizes = [72, 96, 128, 144, 152, 192, 384, 512];
        const manifest = {
            name: (extra && extra.businessName) || 'Multiversity',
            short_name: (extra && extra.businessName) || 'Multiversity',
            theme_color: '#0f5292',
            background_color: '#ffffff',
            display: 'standalone',
            scope: './',
            start_url: './',
            icons: sizes.map(s => ({
                src: `${this.deployUrl}assets/images/${theme}-theme/icons/icon-${s}x${s}.png`,
                sizes: `${s}x${s}`,
                type: 'image/png',
                purpose: 'maskable any',
            })),
        };
        const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
        const link = document.querySelector('link[rel="manifest"]');
        if (link) {
            link.href = URL.createObjectURL(blob);
        }
    }
    resolveTheme(theme) {
        if (!theme) {
            const extra = this.extendedRealmConfigs.getValue();
            if (!extra || !extra.theme) {
                return null;
            }
            theme = extra.theme;
            if (localStorage.getItem('darkMode') === 'true') {
                theme = theme + '-dark';
            }
        }
        return theme;
    }
}
RealmSettingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RealmSettingService_Factory() { return new RealmSettingService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.NbThemeService), i0.ɵɵinject(i3.TextChangeService), i0.ɵɵinject(i4.Title), i0.ɵɵinject(i5.DEPLOY_URL)); }, token: RealmSettingService, providedIn: "root" });
